import bcrypt from "bcryptjs-react";
import { axiosInstance } from "@/resources/requestInfo";
import { changePassRoutes } from "@/redux/profile/settings/changePass/routes";

export const hashTokenHelper = async () => {
	const response = await axiosInstance.get(changePassRoutes.GET_TOKEN_HASH);
	const token = response.data.token;
	const salt = "$2a$09$Z.QowA0wbOZz0uV5MNKtBO";

	return await new Promise((resolve, reject) => {
		bcrypt.hash(token, salt, (err, hash) => {
			if (err) {
				console.error('Ошибка хэширования:', err);
				reject(err);
			} else {
				resolve(hash);
			}
		});
	});
};